import React, { useState } from 'react';
import { galleryData } from '../data/mock';
import { X, ZoomIn } from 'lucide-react';

const GallerySection = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const openLightbox = (image) => {
    setCurrentImage(image);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setCurrentImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <section id="gallery" className="py-24 md:py-32 bg-white">
      <div className="container mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="max-w-4xl mb-16 md:mb-20">
          <span className="text-gray-500 text-sm uppercase tracking-widest font-medium mb-4 block">
            {galleryData.subtitle}
          </span>
          <h2 className="text-black text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight uppercase">
            {galleryData.title}
          </h2>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Main large image - Aerial Farm View */}
          <div
            className="md:col-span-2 lg:col-span-2 relative group cursor-pointer overflow-hidden"
            onClick={() => openLightbox(galleryData.images[0])}
          >
            <img
              src={galleryData.images[0].src}
              alt={galleryData.images[0].alt}
              className="w-full aspect-[16/9] object-cover grayscale hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <ZoomIn className="w-12 h-12 text-white" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black to-transparent">
              <p className="text-white text-lg font-semibold">
                {galleryData.images[0].caption}
              </p>
            </div>
          </div>

          {/* Cattle Feeding Image 1 */}
          <div
            className="relative group cursor-pointer overflow-hidden aspect-square"
            onClick={() => openLightbox(galleryData.images[1])}
          >
            <img
              src={galleryData.images[1].src}
              alt={galleryData.images[1].alt}
              className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <ZoomIn className="w-8 h-8 text-white" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black to-transparent">
              <p className="text-white text-sm font-semibold">
                {galleryData.images[1].caption}
              </p>
            </div>
          </div>

          {/* Cattle Feeding Image 2 */}
          <div
            className="relative group cursor-pointer overflow-hidden aspect-square"
            onClick={() => openLightbox(galleryData.images[2])}
          >
            <img
              src={galleryData.images[2].src}
              alt={galleryData.images[2].alt}
              className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <ZoomIn className="w-8 h-8 text-white" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black to-transparent">
              <p className="text-white text-sm font-semibold">
                {galleryData.images[2].caption}
              </p>
            </div>
          </div>

          {/* Kalite Kontrol Image */}
          <div
            className="relative group cursor-pointer overflow-hidden aspect-square"
            onClick={() => openLightbox(galleryData.images[3])}
          >
            <img
              src={galleryData.images[3].src}
              alt={galleryData.images[3].alt}
              className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <ZoomIn className="w-8 h-8 text-white" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black to-transparent">
              <p className="text-white text-sm font-semibold">
                {galleryData.images[3].caption}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {lightboxOpen && currentImage && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            onClick={closeLightbox}
            className="absolute top-6 right-6 text-white hover:text-gray-300 transition-colors"
            aria-label="Close"
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={currentImage.src}
            alt={currentImage.alt}
            className="max-w-full max-h-[90vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default GallerySection;
